import React, { useState, useEffect } from 'react';
import { Empty, Spin } from 'antd';
import Api from "../../../../api";
import "./index.scss";

let defalutPolicyThemeList = [];
const knowledgeTypeList = ({
    treeSelectChange
}) => {
    
    const [knowledgeType, setKnowledgeType] = useState([]);

    const [treeSpinning, setTreeSpinning] = useState(false);

    const [checkId, setCheckId] = useState('all');

    useEffect(() => { 
        getInitDate();
    }, [])

    const getInitDate = async() => {
        setTreeSpinning(true);
        try{
            const res = await Api.Knowledge.getAllKnowledger({});
            setTreeSpinning(false);
            if(res && res.code === 0){
                setKnowledgeType([
                    {knowledgeTypeName:"全部",id:"all"},
                    ...res.data
                ]);
            }
        }catch(error){
            setTreeSpinning(false);
        }
        
    }


    const changeId = (id) => {
        setCheckId(id);
        treeSelectChange({
            collectKnowledgeTypeId:id === 'all' ? '' : id,
        });
    }

    return(
        <div className="knowledgeTypeListFrameV7">
            <div className="scrollBox">
                <Spin spinning={treeSpinning}>
                {(knowledgeType && knowledgeType.length > 0) ?
                    knowledgeType.map((item, index) => (
                        <div key={item.id} className={`listItem ${checkId === item.id ? 'active':''}`} onClick={()=>changeId(item.id)}>{item.knowledgeTypeName}</div>
                    )):
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }</Spin>
            </div>
        </div>
    )
}

export default knowledgeTypeList;
